export default __webpack_public_path__ + "static/media/Browse_folder.f8a4c0a7.svg";